import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _flexbox from "../dict/flexbox.js";
import _quillClasses from "../dict/quillClasses.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const convertToHtml = _convertToHtml;
const quillClasses = _quillClasses;
const flexbox = _flexbox;
const convertToPlainText = _convertToPlainText;
let alignmentMapping = {
  "L": "left",
  "R": "right",
  "C": "center"
};
function calculatePosition(text, alignment, v, h, win) {
  let position = {
    xPos: "center",
    yPos: "end"
  };
  let highestEnd = text.length + v;

  // Vertical position (h parameter on 19-row grid)
  // Convert to percentage then determine flexbox value
  let yPercentage = (h + 2) / 19 * 100;
  if (yPercentage <= 33) {
    position.yPos = "start";
  } else if (yPercentage >= 67) {
    position.yPos = "end";
  } else {
    position.yPos = "center";
  }

  // Horizontal position (v parameter on 40-column grid)
  if (alignment === "center") {
    position.xPos = "center";
  } else {
    // Calculate percentage for horizontal position
    let xPercentage;
    if (alignment === "left") {
      xPercentage = (v + 4) / 40 * 100;
    } else {
      xPercentage = (v + 5) / 40 * 100;
    }
    if (xPercentage <= 33) {
      position.xPos = "start";
    } else if (xPercentage >= 67) {
      position.xPos = "end";
    } else {
      position.xPos = "center";
    }
  }
  return position;
}
export default {
  decode: function (input, options) {
    let events = [];
    let subtitles = JSON.parse(input);
    subtitles.forEach(subtitle => {
      let ccEvent = new Event({
        alignment: alignmentMapping[subtitle.justification] || "center",
        start: tcLib.tcMsToSec(subtitle.start, options.frameRate, options.dropFrame),
        end: tcLib.tcMsToSec(subtitle.end, options.frameRate, options.dropFrame)
      });
      let plainText = convertToPlainText(subtitle.text);
      ccEvent.text = convertToHtml(subtitle.text, [quillClasses.align[ccEvent.alignment]]);
      let position = calculatePosition(plainText, ccEvent.alignment, parseInt(subtitle.vertical), parseInt(subtitle.horizontal), options.window);
      ccEvent.xPos = position.xPos;
      ccEvent.yPos = position.yPos;
      events.push(ccEvent);
      // console.log(ccEvent);
    });
    return events;
  },
  encode: function (eventGroup, options) {
    throw new Error("JSON Custom 01 files are not supported for encoding by Closed Caption Converter.");
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};